<template>
      <v-card>
        <v-card-title class="">
          
            <span class="headline black--text"
              >Project Filtering</span
            >
        </v-card-title>
        
        <v-card-text>
          <div>
            <v-card-text
              v-for="(filter_groups, index) in getFilteringData()"
              v-bind:key="index"
            >
              <v-layout>
                <v-flex xs12 sm10>
                <div v-for="(filtering_parameter, index1) in filter_groups.add_filterings"
                v-bind:key="index1">
                  <v-layout class="mb-2">
                    <v-flex class="capitalize" xs12 sm2>{{ parameterTypeName(filtering_parameter.filtering_parameter_id) }}</v-flex> 
                    <v-flex class="capitalize" xs12 sm2>{{ operatorName(filtering_parameter.comparison_operator_id) }}</v-flex>
                    <v-flex class="capitalize" xs12 sm8>{{ getContent(filtering_parameter) }}</v-flex>
                  </v-layout>  
                </div>

                </v-flex>
                <v-flex xs12 sm2><v-btn class="fa-pull-right"> Group - {{ index+1 }} </v-btn></v-flex>
                
                
              </v-layout>
              <v-divider></v-divider>
            </v-card-text>
          </div>
        </v-card-text>
      </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    project_data: Object,
  },
  data: () => ({
    
  }),

  computed: {
    ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {},

  created() {
    // this.getComponent(this.project_id);
    
  },
  methods: { 
    getFilteringData(){
      
      return JSON.parse(this.project_data.filtering_parameters);
    },
    parameterTypeName(param_id){
      return this.indexData.ProjectFilteringParameter[(parseInt(param_id)-1)].parameter_name;
    },
    operatorName(param_id){          
      return this.indexData.operators[(parseInt(param_id)-1)].name;
    },
    getContent(filtering_parameter){  
      if(filtering_parameter.filtering_parameter_id==1){
        return filtering_parameter.age1;
      }else if(filtering_parameter.filtering_parameter_id==2){
       let genderData = [];
       filtering_parameter.gender_id.forEach(element => {
        genderData.push(this.indexData.genders[element-1].name);
        });
        return genderData.join(", ");
      }else if(filtering_parameter.filtering_parameter_id==3){
       let divisionData = [];
       filtering_parameter.division_id.forEach(element => {
        divisionData.push(this.indexData.divisions[element-1].english_title);
        });
        return divisionData.join(", ");
      }else if(filtering_parameter.filtering_parameter_id==4){
       let districtData = [];
       filtering_parameter.district_id.forEach(element => {
        districtData.push(this.indexData.districts[element-1].english_title);
        });
        return districtData.join(", ");   
      }else if(filtering_parameter.filtering_parameter_id==5){
       let educationData = [];
       filtering_parameter.education_id.forEach(element => {
        educationData.push(this.indexData.educations[element-1].name);
        });
        return educationData.join(", ");
      }else if(filtering_parameter.filtering_parameter_id==6){
       let professionData = [];
       filtering_parameter.profession_id.forEach(element => {
        professionData.push(this.indexData.professions[element-1].name);
        });
        return professionData.join(", ");
      }else if(filtering_parameter.filtering_parameter_id==7){
       let incomeData = [];
       filtering_parameter.income_id.forEach((value) => {
          incomeData.push(this.indexData.income[parseInt(value) - 1].name);
        });
        return incomeData.join(", ");
      }else{
        return "N/A";
      }
    },
  },
};
</script>
<style scoped>
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.capitalize{
  text-transform: capitalize;
}
</style>